/**
 * CustomSelect Component
 * A custom select component based on Material-UI's FormControl, InputLabel, MenuItem, and Select components.
 *
 * @param {Object} props - The props object containing the following properties:
 *   @param {string} label - The label text to be displayed above the select component.
 *   @param {any} value - The current selected value of the select component.
 *   @param {Array<{ id: any, label: string }>} options - An array of option objects to populate the select component.
 *   @param {Function} onChange - The callback function to be invoked when the select value changes.
 *
 * @returns {JSX.Element} - The rendered CustomSelect component.
 */

import { ISelect } from './Select.types';
import { SvgIcon, MenuItem } from '@mui/material';
import { StyledFormControl, StyledSelect, StyledSelectContainer, StyledSelectLabel } from './Select.styles';

const CustomSelect = (props: ISelect) => {
  return (
    <StyledSelectContainer>
      {props.label && <StyledSelectLabel>{props.label}</StyledSelectLabel>}
      <StyledFormControl size={props.size} fullWidth={props.fullWidth}>
        <StyledSelect
          defaultValue={props.defaultValue}
          value={props.value || ''}
          onChange={props.onChange}
          onClose={() => {
            setTimeout(() => {
              (document.activeElement as HTMLElement)?.blur();
            }, 0);
          }}
          fullWidth
          displayEmpty
          inputProps={{ 'aria-label': props.label || 'Select' }}
          sx={props.sx}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                marginTop: 8,
              },
            },
          }}
        >
          {props.options.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.icon && <SvgIcon>{option.icon}</SvgIcon>}
              {option.italic && <em>{option.label}</em>}
              {!option.italic && option.label}
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </StyledSelectContainer>
  );
};
export default CustomSelect;
